import { useIntl } from "react-intl";
import * as yup from "yup";
import { parse } from "date-fns";
import messages from "./messages.i18n";
import { PeekInputCheckbox } from "@piiqtechnologies/ui-components";
import { DatePeriodFilter } from "./date-period-filter/DatePeriodsFilter";
import { CalendarDateSelector } from "..";
export const FilterDatesFormValidationSchema = ({ isSingleDate, datePeriod }) => {
    const intl = useIntl();
    return yup.object({
        startDate: yup
            .date()
            .transform((_value, originalValue) => parse(originalValue, "MM/dd/yy", new Date()))
            .typeError(intl.formatMessage(messages.filterStartDateError))
            .when([], () => {
            return datePeriod === undefined
                ? yup.date().required(intl.formatMessage(messages.filterStartDateRequired))
                : yup.date().notRequired();
        }),
        endDate: yup
            .date()
            .transform((_value, originalValue) => parse(originalValue, "MM/dd/yy", new Date()))
            .typeError(intl.formatMessage(messages.filterEndDateError))
            .when(["startDate"], (startDate, schema) => {
            return datePeriod === undefined && !isSingleDate
                ? schema
                    .required(intl.formatMessage(messages.filterEndDateRequired))
                    .test("is-greater", intl.formatMessage(messages.filterEndDateBeforeStartDateError), function (endDate) {
                    return !endDate || !startDate || endDate >= startDate;
                })
                : yup.date().notRequired();
        }),
    });
};
export const FilterDatesFormInitialValues = {
    startDate: "",
    endDate: "",
    singleDate: false,
    datePeriod: 0,
};
export const FilterDatesFormFields = () => {
    const intl = useIntl();
    return {
        singleDate: {
            singeDate: [
                {
                    id: "singleDate",
                    label: intl.formatMessage(messages.filterSingleDateLabel),
                    placeholder: intl.formatMessage(messages.filterSingleDateLabel),
                    required: false,
                    columns: 12,
                    component: PeekInputCheckbox,
                    type: "checkbox",
                },
            ],
        },
        startDate: {
            startDate: [
                {
                    id: "startDate",
                    label: "",
                    placeholder: intl.formatMessage(messages.filterStartDatePlaceholder),
                    required: false,
                    columns: 12,
                    isAbsolute: false,
                    disablePast: false,
                    component: CalendarDateSelector,
                },
            ],
        },
        endDate: {
            endDate: [
                {
                    id: "endDate",
                    label: "",
                    placeholder: intl.formatMessage(messages.filterEndDatePlaceholder),
                    required: false,
                    columns: 12,
                    isAbsolute: false,
                    disablePast: false,
                    component: CalendarDateSelector,
                },
            ],
        },
        datePeriod: {
            datePeriod: [
                {
                    id: "datePeriod",
                    label: "",
                    placeholder: "",
                    required: false,
                    columns: 12,
                    component: DatePeriodFilter,
                },
            ],
        },
    };
};
